module.exports = __webpack_public_path__ + "static/media/superSmashBros.c9618e8b.png";